import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { TransactionStatus } from '../models/report.model';
import { TransactionStatusApi } from '../api/transaction-status.api';
import { TransactionStatusMapper } from '../api/mappers/transaction-status.mapper';

@Injectable({ providedIn: 'root' })
export class TransactionStatusService {
  private readonly _api = inject(TransactionStatusApi);
  private readonly _mapper = new TransactionStatusMapper();

  public list(): Observable<TransactionStatus[]> {
    return this._api.list().pipe(map((dtos) => this._mapper.fromDtoList(dtos)));
  }
}
